<div class="row w-100"
  style="position:absolute; top:0; z-index:1050">
<div class="col w-100 pr-4">
<div class="card w-100 mt-3 border border-primary">
<div class="card-header">
<h5 class="card-title" ><button
  type="button"
  (click)="closePopup()"
  class="btn btn-outline-secondary float-end"
  >&times;</button>
{{ question.section }}.{{ question.id }} {{ question.title }}</h5>
</div>
<div class="card-body">
<div [innerHtml]="question.description"></div>
<div *ngIf="! tabs">This question has no help</div>
<ul class="nav nav-tabs" id="QuestionHelpTabNav" role="tablist">
  <li *ngFor="let tab of tabs; first as isFirst"
    class="nav-item" role="presentation"
  ><a
    [ngClass]="{'nav-link': true, 'active': isFirst}"
    id="questionhelp{{ tab.slug }}"
    data-bs-toggle="tab"
    href="#questionhelppanel{{ tab.slug }}"
    role="tab"
    [attr.aria-controls]="'questionhelppanel' + tab.slug"
    [attr.aria-selected]="isFirst"
    title="{{ tab.description }}"
  >{{ tab.title }}</a></li>
</ul>

<div class="tab-content" id="QuestionHelpTabContent">
  <div *ngFor="let tab of tabs"
    class="tab-pane fade show active"
    id="questionhelppanel{{ tab.slug }}"
    role="tabpanel"
    [attr.aria-labelledby]="'questionhelptab' + tab.slug"
  >
    <div  *ngFor="let tabitem of tabitems">
      <div *ngIf="tab.slug === tabitem.help_type">
        <h5>{{ tabitem.title }}</h5>
        <div [innerHtml]="tabitem.description"></div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="card-footer">
<button
  type="button"
  (click)="closePopup()"
  class="btn btn-secondary float-end"
  i18n="Close">BUTTON_CLOSE</button>
</div>
</div>
</div>
</div>
